/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbDiplomeGridDto } from './FcbDiplomeGridDto';
import {
    FcbDiplomeGridDtoFromJSON,
    FcbDiplomeGridDtoFromJSONTyped,
    FcbDiplomeGridDtoToJSON,
} from './FcbDiplomeGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbDiplomeGridDtoPaginatedResults
 */
export interface FcbDiplomeGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbDiplomeGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbDiplomeGridDto>}
     * @memberof FcbDiplomeGridDtoPaginatedResults
     */
    results?: Array<FcbDiplomeGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbDiplomeGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbDiplomeGridDtoPaginatedResults interface.
 */
export function instanceOfFcbDiplomeGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbDiplomeGridDtoPaginatedResultsFromJSON(json: any): FcbDiplomeGridDtoPaginatedResults {
    return FcbDiplomeGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbDiplomeGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbDiplomeGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbDiplomeGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbDiplomeGridDtoPaginatedResultsToJSON(value?: FcbDiplomeGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbDiplomeGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

